<template>
    <v-dialog
            ref="dialog"
            v-model="modal"
            :return-value.sync="date"
            width="310px"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                    v-model="date"
                    label="请选择月份"
                    prepend-icon="event"
                    readonly
                    v-bind="attrs"
                    v-on="on"
            ></v-text-field>
        </template>
        <v-date-picker v-model="date"
                       type="month"
                       :allowed-dates="allowedDates"
                       scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="modal = false">取消</v-btn>
            <v-btn text color="primary" @click="confirm">确定</v-btn>
        </v-date-picker>
    </v-dialog>
</template>

<script>
  export default {
    name: "",
    props:{
      value:{
        type:String,
        default:''
      },
      allowedDates:{
        type:Function,
        default:() => {
          return true
        }
      }
    },
    data() {
      return {
        modal: false,
        date: ''
      }
    },
    watch: {
      value(newValue, oldValue){
        this.date=newValue;
      },
      date(newValue, oldValue) {
        console.log(newValue, 'newValue');
        this.$emit('input',newValue);
      },
    },
    methods:{
      // allowedDates(val){
      //   if(this.allowedLtDates){
      //     return Date.parse(val)< Date.now()
      //   }else{
      //     return true
      //   }
      // },
      confirm(){
        this.$refs.dialog.save(this.date);
        this.$emit('change',this.date);
      },
    },
    created(){
      this.date=this.value;
    }
  }
</script>

<style scoped>

</style>